document.addEventListener("DOMContentLoaded", () => {
    /* ---------------------------------------------
    VARIABLES
  --------------------------------------------- */
    const headerTabs = document.querySelectorAll(".Drawer__header-item");
    const sections = document.querySelectorAll(".SidebarMenu__Nav-content");
    const submenuBtns = document.querySelectorAll(".subdrawer-tab-button");
    const closeSubmenuBtns = document.querySelectorAll(
        ".subdrawer-close-button"
    );
    const drawerButton = document.getElementById("open-siedebar-menu");
    const sidebarMenu = document.getElementById("sidebar-menu");
    const closeButton = document.getElementById("Drawer__Close-Icon");

    const openSdiebarMinicartButton = document.getElementById(
        "open-sidedar-minicar"
    );
    const closeSdiebarMinicartButton =
        document.getElementById("close-sidebar-cart");
    const miniCart = document.getElementById("sidebar-cart");
    const overlay = document.getElementById("drawer-overlay");

    function hideSidebarMenu() {
        if (!sidebarMenu) return;
        sidebarMenu.setAttribute("aria-hidden", "false");
    }

    function closeSidebarMenu() {
        const sidebarMenu = document.getElementById("sidebar-menu");
        if (!sidebarMenu) return;
        sidebarMenu.setAttribute("aria-hidden", "true");
    }

    drawerButton?.addEventListener("click", () => {
        console.log("ksk");
        hideSidebarMenu();
    });

    closeButton?.addEventListener("click", () => {
        closeSidebarMenu();
    });

    /* ---------------------------------------------
    FUNCIÓN: Cambiar pestaña principal
  --------------------------------------------- */
    function activateMainTab(index) {
        headerTabs.forEach((btn, i) => {
            btn.classList.toggle("current", i === index);
            sections[i].classList.toggle("selected", i === index);
        });
    }

    // Seleccionar pestaña inicial
    if (headerTabs.length > 0) activateMainTab(0);

    // Eventos de las pestañas principales
    headerTabs.forEach((btn, i) => {
        btn.addEventListener("click", () => activateMainTab(i));
    });

    /* ---------------------------------------------
    FUNCIÓN: Abrir submenu
  --------------------------------------------- */
    submenuBtns.forEach((button) => {
        button.addEventListener("click", (event) => {
            const id = event.currentTarget.id; // el botón real
            const submenu = document.querySelector(`.${id}`);

            if (submenu) {
                submenu.classList.add("submenu-active");
            } else {
                console.warn(`No se encontró el submenu con clase .${id}`);
            }
        });
    });

    /* ---------------------------------------------
    FUNCIÓN: Cerrar submenu
  --------------------------------------------- */
    closeSubmenuBtns.forEach((button) => {
        button.addEventListener("click", (event) => {
            const dataAttr = event.currentTarget.getAttribute("data-submenu");
            const submenu = document.querySelector(`.${dataAttr}`);

            if (submenu) {
                submenu.classList.remove("submenu-active");
            } else {
                console.warn(
                    `No se encontró el submenu con clase .${dataAttr}`
                );
            }
        });
    });

    // 🛒 Actualizar contenido del minicart
    async function actualizarCarrito() {
        try {
            const response = await fetch("/cart.js");
            const data = await response.json();
            const minicartContainer = document.getElementById(
                "minicart-product-container"
            );
            if (!minicartContainer) return;

            minicartContainer.innerHTML = "";

            const formatter = new Intl.NumberFormat("es-MX", {
                style: "currency",
                currency: "MXN",
            });

            if (data.items.length === 0) {
                minicartContainer.innerHTML =
                    '<p class="Cart__Empty Heading u-h5">Tu carrito está vacío</p>';
                return;
            }

            data.items.forEach((item) => {
                const hasDiscount =
                    item.original_line_price > item.final_line_price;
                const currentPrice = formatter.format(
                    item.final_line_price / 100
                );
                const oldPrice = formatter.format(
                    item.original_line_price / 100
                );

                const productHTML = `
          <div class="CartItem flex gap-4 py-3 border-b">
            <div class="CartItem__ImageWrapper" style="flex-shrink:0;">
              <img
                class="CartItem__Image"
                src="${item.image}"
                alt="${item.product_title}"
                width="90"
                height="90"
                loading="lazy"
              >
            </div>
            <div class="CartItem__Details flex-1 flex flex-col justify-between">
              <div>
                <p class="CartItem__Title font-semibold text-sm leading-tight">${
                    item.product_title
                }</p>
                <div class="CartItem__Prices">
                  <span class="CartItem__Price ">${currentPrice}</span>
                  ${
                      hasDiscount
                          ? `<s class="CartItem__OldPrice text-xs text-gray-500">${oldPrice}</s>`
                          : ""
                  }
                </div>
              </div>
              <div class="CartItem__Bottom flex justify-between items-center mt-2">
                <div class="CartItem__QuantityControl flex items-center gap-2" data-item-key="${
                    item.key
                }">
                  <button type="button" class="CartItem__QtyBtn" data-action="minus">−</button>
                  <input type="text" readonly value="${
                      item.quantity
                  }" class="CartItem__QtyInput">
                  <button type="button" class="CartItem__QtyBtn" data-action="plus">+</button>
                </div>
              </div>
            </div>
          </div>
        `;

                minicartContainer.insertAdjacentHTML("beforeend", productHTML);
            });

            attachMiniCartListeners();
        } catch (error) {
            console.error("Error al actualizar el carrito:", error);
        }
    }

    // ➕➖ Control de cantidad
    function attachMiniCartListeners() {
        document
            .querySelectorAll(".CartItem__QuantityControl")
            .forEach((control) => {
                const itemKey = control.getAttribute("data-item-key");
                const input = control.querySelector(".CartItem__QtyInput");

                control.querySelectorAll(".CartItem__QtyBtn").forEach((btn) => {
                    btn.addEventListener("click", async () => {
                        const action = btn.getAttribute("data-action");
                        let currentQty = parseInt(input.value);

                        if (action === "minus" && currentQty > 1) {
                            await updateCartItem(itemKey, currentQty - 1);
                        } else if (action === "plus") {
                            await updateCartItem(itemKey, currentQty + 1);
                        } else if (action === "minus" && currentQty === 1) {
                            await removeCartItem(itemKey);
                        }
                    });
                });
            });
    }

    async function updateCartItem(itemKey, newQty) {
        await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: itemKey, quantity: newQty }),
        });
        await actualizarCarrito();
    }

    async function changeCartItemQuantity(itemKey, newQty) {
        const res = await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: itemKey, quantity: newQty }),
        });
        await res.json();
        await actualizarCarrito();
    }

    async function removeCartItem(itemKey) {
        const cartItem = document
            .querySelector(`[data-item-key="${itemKey}"]`)
            ?.closest(".CartItem");
        if (cartItem) {
            cartItem.classList.add("fade-out");
            setTimeout(() => cartItem.remove(), 300);
        }
        await changeCartItemQuantity(itemKey, 0);
    }

    // 🛒 Funciones para abrir / cerrar el minicart
    function openSidebar() {
        const sidebar = document.getElementById("sidebar-cart");
        const overlay = document.getElementById("drawer-overlay");

        actualizarCarrito();
        if (!sidebar) return;

        sidebar.classList.add("is-open");
        sidebar.setAttribute("aria-hidden", "false");
        sidebar.removeAttribute("inert");
        sidebar.style.pointerEvents = "auto";

        document.body.classList.add("body-no-scroll");

        if (overlay) overlay.classList.add("active");
    }

    function closeSidebar() {
        const sidebar = document.getElementById("sidebar-cart");
        const overlay = document.getElementById("drawer-overlay");

        if (!sidebar) return;

        // Cerrar
        sidebar.classList.remove("is-open");
        sidebar.setAttribute("aria-hidden", "true");

        sidebar.style.pointerEvents = "none";

        document.body.classList.remove("body-no-scroll");

        if (overlay) overlay.classList.remove("active");
    }

    if (miniCart) {
        miniCart.addEventListener("click", (event) => {
            event.stopPropagation();
        });
    }

    if (overlay) overlay.addEventListener("click", closeSidebar);

    // Botones "Agregar al carrito"
    document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
        form.addEventListener("submit", async (e) => {
            e.preventDefault();
            const formData = new FormData(form);
            const variantId = formData.get("id");
            const quantity = formData.get("quantity") || 1;

            await fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: variantId, quantity }),
            });

            await actualizarCarrito();
            openSidebar();
        });
    });

    openSdiebarMinicartButton.addEventListener("click", () => {
        openSidebar();
    });

    closeSdiebarMinicartButton.addEventListener("click", () => {
        closeSidebar();
    });

    function actualizarBarraDeProgreso() {
        fetch("/cart.js")
            .then((response) => response.json())
            .then((data) => {
                let totalCart = (data.total_price / 100).toFixed(2);
                let objetivo = 799;
                let porcentaje = (totalCart / objetivo) * 100;
                let barraDeProgreso = document.querySelector(".progreso");
                let messageBar = document.getElementById("message-bar");
                let faltante = objetivo - totalCart;

                barraDeProgreso.style.transition = "width 0.5s ease-in-out";

                if (porcentaje >= 100) {
                    barraDeProgreso.style.width = "100%";
                    messageBar.innerHTML =
                        "Conseguiste el envío <span>¡GRATIS!</span>";
                    barraDeProgreso.textContent = "100%";
                } else {
                    barraDeProgreso.style.width = porcentaje + "%";
                    messageBar.innerHTML = `Te faltan $ ${faltante} para obtener el envío <span>¡GRATIS!</span>`;
                    barraDeProgreso.textContent = porcentaje.toFixed(0) + "%";
                }
            })
            .catch((error) => {
                console.error(
                    "Error al actualizar la barra de progreso:",
                    error
                );
            });
    }

    // Guardamos el fetch original
    const originalFetch = window.fetch;

    // Sobrescribimos fetch para interceptar todas sus llamadas
    window.fetch = async (...args) => {
        const response = await originalFetch(...args);

        // Endpoints del carrito que indican cambio
        const cartEndpoints = [
            "/cart/add",
            "/cart/change",
            "/cart/update",
            "/cart/clear",
        ];

        // Si la URL de la petición incluye alguno de estos endpoints
        if (
            typeof args[0] === "string" &&
            cartEndpoints.some((endpoint) => args[0].includes(endpoint))
        ) {
            actualizarBarraDeProgreso(); // Actualizar la barra automáticamente
        }

        return response;
    };

    // Ejecutar la barra una vez al cargar la página
    actualizarBarraDeProgreso();
});

document.addEventListener("DOMContentLoaded", () => {
    const menuItems = document.querySelectorAll(
        '.HorizontalList__Item[aria-haspopup="true"]'
    );

    menuItems.forEach((item) => {
        const submenu = item.querySelector(".MegaMenu, .DropdownMenu");
        if (!submenu) return;

        item.addEventListener("mouseenter", () => {
            submenu.setAttribute("aria-hidden", "false");
        });

        item.addEventListener("mouseleave", () => {
            submenu.setAttribute("aria-hidden", "true");
        });
    });
});

document.addEventListener("DOMContentLoaded", () => {
    const menuItems = document.querySelectorAll(
        '.HorizontalList__Item[aria-haspopup="true"]'
    );

    menuItems.forEach((item) => {
        const submenu = item.querySelector(".MegaMenu, .DropdownMenu");
        if (!submenu) return;

        item.addEventListener("mouseenter", () => {
            submenu.setAttribute("aria-hidden", "false");
        });

        item.addEventListener("mouseleave", () => {
            submenu.setAttribute("aria-hidden", "true");
        });
    });
});
